import apiClient from "../utils/axiosUtil";
import { apiClientMultipart } from "../utils/axiosUtil";

export const saveArticle = async (articleData) => {
  try {
    return await apiClient.post('/admin/articles/saveArticle', JSON.stringify(articleData));
  } catch (error) {
    return error;
  }
}

export const getArticle = async (id) => {
  try {
    return await apiClient.post(`/admin/articles/getArticle?id=${id}`);
  } catch (error) {
    return error;
  }
}

export const updateArticle = async (articleData) => {
  try {
    return await apiClient.put(`/admin/articles/updateArticle`, JSON.stringify(articleData));
  } catch (error) {
    return error;
  }
}

export const publishArticle = async (id) => {
  try {
    return await apiClient.get(`/admin/articles/publishArticle?id=${id}`);
  } catch (error) {
    return error;
  }
}

export const deleteArticle = async (id) => {
  try {
    return await apiClient.delete(`/admin/articles/deleteArticle?id=${id}`);
  } catch (error) {
    return error;
  }
} 

export const getAllArticles = async () => {
  try {
    return await apiClient.get('/admin/articles/getAllArticles');
  } catch (error) {
    return error;
  }
}

export const uploadThumbnail = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    return await apiClient.post("/admin/articles/uploadThumbnail", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true
    });
  } catch (error) {
    return error;
  }
}